module.exports = __webpack_public_path__ + "static/media/dalian2.bce21dbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/imgForTest/dalian2.jpg
// module id = 1172
// module chunks = 0